// ─────────────────────────────────────────────────────────────────────────────
// src/api/api.js  —  Single source of truth for all API configuration
//
// TO SWITCH TO PRODUCTION: change BASE_URL only. Nothing else changes.
// ─────────────────────────────────────────────────────────────────────────────
export const BASE_URL = process.env.NODE_ENV === "production" 
  ? "https://solviotech.com/api" 
  : "http://127.0.0.1:5000/api";  

export const ENDPOINTS = {

  // ── Auth ──────────────────────────────────────────────────
  login:      `${BASE_URL}/login`,
  register:   `${BASE_URL}/register`,
  me:         `${BASE_URL}/me`,
  googleAuth: `${BASE_URL}/auth/google`,   // ✅ Google OAuth

  // ── Core Content ──────────────────────────────────────────
  hero:             `${BASE_URL}/hero`,
  stats:            `${BASE_URL}/stats`,
  services:         `${BASE_URL}/services`,
  projects:         `${BASE_URL}/projects`,
  featuredProjects: `${BASE_URL}/projects`,   // filtered client-side

  // ── Home Sections ─────────────────────────────────────────
  processSteps: `${BASE_URL}/process-steps`,
  whyUs:        `${BASE_URL}/why-us`,

  // ── Navigation & Layout ───────────────────────────────────
  navLinks:     `${BASE_URL}/nav-links`,
  footerLinks:  `${BASE_URL}/footer-links`,
  socialLinks:  `${BASE_URL}/social-links`,

  // ── About ─────────────────────────────────────────────────
  about:      `${BASE_URL}/about`,
  values:     `${BASE_URL}/values`,
  milestones: `${BASE_URL}/milestones`,

  // ── Team ──────────────────────────────────────────────────
  team_members: `${BASE_URL}/team-members`,
  skills:       `${BASE_URL}/skills`,

  // ── Tech Stack ────────────────────────────────────────────
  technologies: `${BASE_URL}/technologies`,

  // ── Testimonials ──────────────────────────────────────────
  testimonials: `${BASE_URL}/testimonials`,

  // ── Services Page ─────────────────────────────────────────
  serviceOfferings: `${BASE_URL}/services`,

  // ── Pricing ───────────────────────────────────────────────
  pricing:           `${BASE_URL}/pricing`,
  pricingGuarantees: `${BASE_URL}/pricing-guarantees`,

  // ── Portfolio ─────────────────────────────────────────────
  portfolioCategories: `${BASE_URL}/portfolio-categories`,

  // ── Contact ───────────────────────────────────────────────
  faq:              `${BASE_URL}/faq`,
  contactInfo:      `${BASE_URL}/contact-info`,
  contact_messages: `${BASE_URL}/contact-messages`,

  // ── Chatbot ───────────────────────────────────────────────
  chatReplies: `${BASE_URL}/chat-replies`,
  chatbotAsk:  `${BASE_URL}/chatbot/ask`,   // ✅ time-aware greeting + keyword matching
};


export const apiFetch = async (url, options = {}) => {
  const { token, ...rest } = options;

  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(url, { headers, ...rest });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  return res.json();
};

/**
 * Convenience: make an authenticated request using the stored token.
 * Use this inside admin components instead of passing token manually.
 */
export const authFetch = (url, options = {}) => {
  const token = localStorage.getItem("solvio_token");
  return apiFetch(url, { ...options, token });
};
